import SocialSection from 'components/Header/components/SocialSection';
import React from 'react';

import './home.scss';

const Home = () => {
  return (
    <main>
      <SocialSection />
    </main>
  );
};

export default Home;
